import React from 'react'
import { useIntl } from 'react-intl'

import {
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  Button
} from 'mailup-web-components'
import { ContentScheduled } from 'Components/ContentScheduled/ContentScheduled'
import { STORE_KEY_LIST, useStorage } from 'mailup-react-helpers'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'
import { modalShedulingState } from '../recoil/states/page'
import { contentScheduledState } from 'Components/ContentScheduled/recoil/state'
import { sendMessageCallback } from '../recoil/callbacks/callbacks'

const ModalSchedule = () => {
  const intl = useIntl()
  const {
    show,
    isReschedule,
    startDate,
    scheduleTimeZoneCode,
    idScheduledSending
  } = useRecoilValue(modalShedulingState)

  const reset = useResetRecoilState(modalShedulingState)
  const [{ TimeZoneCode: listTimeZoneCode }] = useStorage(STORE_KEY_LIST).values

  const {
    momentUtcDate,
    momentTimeZoneDate,
    timeZone,
    validHour,
    validMinutes,
    validDate
  } = useRecoilValue(contentScheduledState)

  const sendMessage = useRecoilCallback(sendMessageCallback, [])

  const onClickSchedule = () => {
    sendMessage(idScheduledSending, momentUtcDate.toISOString(), timeZone)
  }

  return (
    <Modal show={show} onClose={reset}>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Rcs.SendStatusModalScheduleTitle'
        })}
      />
      <ModalBody>
        <ContentScheduled
          scheduleDate={isReschedule ? startDate : ''}
          scheduleTimeZoneCode={
            isReschedule ? scheduleTimeZoneCode : listTimeZoneCode
          }
          description={intl.formatMessage({
            id: 'Load.Rcs.SendStatusModalScheduleBody'
          })}
        />
      </ModalBody>
      <ModalFoot>
        <Button kind='secondary' onClick={reset}>
          {intl.formatMessage({
            id: 'Load.Rcs.SendStatusModalScheduleBtnCancel'
          })}
        </Button>
        <Button
          kind='primary'
          disabled={!validHour || !validDate || !validMinutes}
          onClick={onClickSchedule}
        >
          {intl.formatMessage({
            id: 'Load.Rcs.SendStatusModalScheduleBtnSet'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalSchedule
